import clsx from "clsx";
import React from "react";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: "none" | "sm" | "md" | "lg";
  shadow?: boolean;
  border?: boolean;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({
  children,
  className = "",
  padding = "md",
  shadow = true,
  border = true,
  onClick,
}) => {
  const paddingClasses = {
    none: "",
    sm: "p-3",
    md: "p-4",
    lg: "p-6",
  };

  return (
    <div
      className={clsx(
        // Base styles
        "bg-white rounded-lg",
        // Padding
        paddingClasses[padding],
        // Shadow
        shadow && "shadow-sm",
        // Border - using PRD border color
        border && "border border-border-default",
        // Interactive
        onClick && "cursor-pointer hover:bg-gray-50 transition-colors",
        className
      )}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {children}
    </div>
  );
};

export default Card;
